/**
 * PagePlaceholder
 *
 * Generic "coming soon" card used by stub pages (Devices, Users, Checkout,
 * Talk groups, Licensing, Network, System, Home) that have not yet been
 * built out after retiring the Workflow wizard.
 */
function PagePlaceholder({ title, icon = 'fa-tools', description }) {
  return (
    <div className="placeholder-card">
      <i className={`fas ${icon}`}></i>
      <h3>{title}</h3>
      <p>{description || 'This section is coming soon.'}</p>
    </div>
  );
}

export default PagePlaceholder;

